/* Native language/country submission only. Does not translate or intercept app globals. */
(() => {
  'use strict';
  const configNode = document.getElementById('LXLocalizationConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const key = `lx-localization:${config.theme}:${config.product}`;
  const ttl = 5 * 60 * 1000;
  let restoring = false;
  let failed = false;
  let checkLate = () => true;
  let submitting = false;
  const productRoot = () => document.querySelector('product-info');
  const quantityInput = () => productRoot()?.querySelector('input[name="quantity"][form]');
  const variantInput = () => productRoot()?.querySelector('form[action*="/cart/add"] input[name="id"]');
  const imageKey = image => image?.getAttribute('src')?.split('?')[0] || '';
  const appFields = () => [...(productRoot()?.querySelectorAll('[data-lx-app-content] input:not([type="file"]):not([type="hidden"]), [data-lx-app-content] select, [data-lx-app-content] textarea') || [])].filter(el => el.name !== 'quantity' && !el.closest('.lx-flow-pricing,ssl-os-vd,.os-vd__volume-discount-deal'));
  const identity = el => el.id || el.name;
  const clear = () => { try { sessionStorage.removeItem(key); } catch { /* Storage can be blocked. */ } };
  const message = (text, focus = true) => {
    let notice = document.getElementById('LXLocaleNotice');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'LXLocaleNotice'; notice.role = 'status'; notice.tabIndex = -1;
      notice.style.cssText = 'padding:12px 16px;margin:12px 0;border:1px solid #dce3c7;border-radius:8px;background:#f6f8ee;color:#29351e;font-size:14px;line-height:1.5;';
      (productRoot() || document.getElementById('MainContent')).prepend(notice);
    }
    notice.textContent = text;
    if (focus) notice.focus();
  };
  const resetForm = form => {
    const language = form.elements.namedItem('language_code');
    const country = form.elements.namedItem('country_code');
    if (language) language.value = config.locale;
    if (country) country.value = config.country;
  };
  const hasArtwork = () => {
    const root = productRoot();
    return root && ([...root.querySelectorAll('input[type="file"]')].some(el => el.files?.length) ||
      root.querySelector('.image-upload .ant-spin-spinning, .image-upload [aria-busy="true"], .ant-upload-list-item, .image-upload a[href]:not([href="#"])'));
  };
  const capture = form => {
    if (!config.product || !productRoot()) return true;
    if (restoring || failed) { document.getElementById('LXLocaleNotice')?.focus(); resetForm(form); return false; }
    // Browsers cannot re-populate file inputs after a navigation. Keep the page intact.
    if (hasArtwork()) { message(config.messages.artwork); resetForm(form); return false; }
    if (!checkLate()) { resetForm(form); return false; }
    const fields = appFields();
    if (fields.some(el => !identity(el) && (el.value || el.checked))) {
      message(config.messages.review); resetForm(form); return false;
    }
    const state = {
      time: Date.now(), product: config.product,
      transition: crypto.randomUUID(), sourceCountry: config.country,
      locale: form.elements.namedItem('language_code')?.value || config.locale,
      country: form.elements.namedItem('country_code')?.value || config.country,
      variant: variantInput()?.value || String(config.variant),
      quantity: quantityInput()?.value ?? '1',
      hasApp: Boolean(productRoot().querySelector('[data-lx-app-content]')),
      hasPricing: Boolean(productRoot().querySelector('.os-vd__tier')),
      fields: fields.filter(identity).map(el => ({key: identity(el), type: el.type, value: el.value, checked: el.checked})),
      swatches: [...productRoot().querySelectorAll('[data-lx-app-content] [id$="image-swatch"]')].map(field => ({
        id: field.id, images: [...field.querySelectorAll('.c-active-option img')].map(imageKey)
      })).filter(field => field.images.length)
    };
    try {
      sessionStorage.setItem(key, JSON.stringify(state));
      if (!sessionStorage.getItem(key)) throw new Error('Storage unavailable');
    } catch { message(config.messages.storage); resetForm(form); return false; }
    const destination = new URL(window.location.href);
    destination.searchParams.set('lx_locale_transition', state.transition);
    if (/^\d+$/.test(state.variant)) destination.searchParams.set('variant', state.variant);
    const returnTo = form.elements.namedItem('return_to');
    if (returnTo) returnTo.value = destination.pathname + destination.search + destination.hash;
    return true;
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[action*="localization"]')) {
      if (restoring && form.matches('form[action*="/cart/add"]')) {
        event.preventDefault(); event.stopImmediatePropagation(); message(config.messages.busy);
      }
      return;
    }
    if (submitting || !capture(form)) { event.preventDefault(); return; }
    window.LXClarityV2?.rememberCountry(form, form.elements.namedItem('country_code')?.value);
    submitting = true;
    form.setAttribute('aria-busy', 'true');
    // No disabled select: the native form still needs its language/country values.
    window.setTimeout(() => { submitting = false; form.removeAttribute('aria-busy'); }, 8000);
  }, true);
  const enhance = scope => {
    scope.querySelectorAll('.lxrh__locale form:not([data-lx-instant])').forEach(form => {
      if (typeof form.requestSubmit !== 'function') return;
      form.dataset.lxInstant = '';
      const button = form.querySelector('button[type="submit"]');
      if (button) { button.hidden = true; button.style.display = 'none'; }
      form.querySelector('[name=country_code]')?.addEventListener('pointerdown', () => window.LXClarityV2?.countryOpened(form));
      form.addEventListener('change', event => {
        if (event.target.matches('select[name="language_code"],select[name="country_code"]')) form.requestSubmit();
      });
    });
  };
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  window.addEventListener('pageshow', () => { submitting = false; document.querySelectorAll('form[action*="localization"]').forEach(form => form.removeAttribute('aria-busy')); });
  if (!config.product) return;
  let state;
  try { state = JSON.parse(sessionStorage.getItem(key)); } catch { clear(); return; }
  if (!state) return;
  const arrival = new URL(window.location.href);
  const intended = Boolean(state.transition && arrival.searchParams.get('lx_locale_transition') === state.transition);
  if (arrival.searchParams.has('lx_locale_transition')) {
    arrival.searchParams.delete('lx_locale_transition');
    window.history.replaceState(window.history.state, '', arrival.pathname + arrival.search + arrival.hash);
  }
  const marketFallback = state.sourceCountry && state.sourceCountry !== state.country && state.country === config.country;
  const valid = intended && state.product === config.product && Date.now() - state.time <= ttl && Date.now() >= state.time &&
    state.country === config.country && (state.locale === config.locale || marketFallback) &&
    String(state.variant) === String(config.variant);
  if (!valid) { clear(); if (intended) message(config.messages.review, false); return; }
  let frame, timer, poll, observer, stableSince = 0, synchronized = false;
  const setValue = (el, value) => {
    const prototype = el instanceof HTMLSelectElement ? HTMLSelectElement.prototype : el instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(prototype, 'value').set.call(el, value);
    if (el === quantityInput() && productRoot()?.quantityBeforeVariant !== undefined) productRoot().quantityBeforeVariant = value;
    el.dispatchEvent(new Event('input', {bubbles: true}));
    el.dispatchEvent(new Event('change', {bubbles: true}));
  };
  const stop = () => {
    observer?.disconnect(); cancelAnimationFrame(frame); clearTimeout(timer); clearInterval(poll);
    restoring = false; productRoot()?.removeAttribute('data-lx-restoring');
  };
  const finish = success => {
    stop(); failed = !success;
    productRoot()?.toggleAttribute('data-lx-restore-failed', failed);
    if (success) { clear(); document.getElementById('LXLocaleNotice')?.remove(); watchLateInitialization(); return; }
    message(config.messages.restore_failed, false);
    const notice = document.getElementById('LXLocaleNotice');
    const retry = document.createElement('button');
    retry.type = 'button'; retry.className = 'button button--secondary'; retry.textContent = config.messages.retry;
    retry.addEventListener('click', begin);
    const review = document.createElement('button');
    review.type = 'button'; review.className = 'button button--secondary'; review.textContent = config.messages.review_current;
    review.addEventListener('click', () => {
      clear(); failed = false; productRoot()?.removeAttribute('data-lx-restore-failed'); notice.remove();
      const field = productRoot()?.querySelector('[data-lx-flow-accessories]');
      const target = field || quantityInput();
      if (target) { target.tabIndex = -1; target.scrollIntoView({block:'center'}); target.focus({preventScroll:true}); }
    });
    notice.append(document.createElement('br'), retry, review);
  };
  const restore = () => {
    if (!restoring) return;
    const root = productRoot(), quantity = quantityInput();
    if (!root || !quantity || !customElements.get('product-info')) return;
    if (state.hasApp && !root.querySelector('[data-lx-app-content] input, [data-lx-app-content] select, [data-lx-app-content] .shopify-width-height')) return;
    if (state.hasPricing && !root.querySelector('.os-vd__tier')) return;
    let matched = true;
    for (const saved of state.swatches || []) {
      const field = [...root.querySelectorAll('[data-lx-app-content] [id$="image-swatch"]')].find(el => el.id === saved.id);
      if (!field) { matched = false; continue; }
      const active = [...field.querySelectorAll('.c-active-option img')].map(imageKey).sort();
      if (JSON.stringify(active) === JSON.stringify([...saved.images].sort())) continue;
      matched = false;
      const options = [...field.querySelectorAll('.shopify-width-height img')];
      const targets = saved.images.map(src => options.filter(img => imageKey(img) === src));
      if (targets.some(list => list.length !== 1)) continue;
      targets.forEach(([img]) => { if (!img.closest('.c-active-option')) img.closest('.shopify-width-height').click(); });
    }
    for (const saved of state.fields || []) {
      const matches = appFields().filter(el => identity(el) === saved.key && el.type === saved.type);
      if (matches.length !== 1) { matched = false; continue; }
      const el = matches[0];
      if (['radio', 'checkbox'].includes(el.type)) {
        if (el.checked !== saved.checked) { matched = false; if (el.type !== 'radio' || saved.checked) el.click(); }
      } else if (el.value !== saved.value) { matched = false; setValue(el, saved.value); }
    }
    const requested = Number(state.quantity), min = Number(quantity.min) || 1, max = Number(quantity.max) || Infinity, step = Number(quantity.step) || 1;
    if (!Number.isSafeInteger(requested) || requested < min || requested > max || (requested - min) % step !== 0) { finish(false); return; }
    if (quantity.value !== String(requested)) { matched = false; setValue(quantity, String(requested)); }
    if (!matched) { stableSince = 0; synchronized = false; return; }
    if (!stableSince) stableSince = Date.now();
    if (Date.now() - stableSince >= 1000) {
      if (!synchronized) { synchronized = true; stableSince = Date.now(); setValue(quantity, String(requested)); }
      else finish(true);
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(() => { frame = 0; restore(); }); };
  let lateTimer, lateEnd;
  const stopLate = () => {
    clearInterval(lateTimer); clearTimeout(lateEnd); checkLate = () => true;
    document.removeEventListener('input', userEdit, true);
    document.removeEventListener('pointerdown', userEdit, true);
    document.removeEventListener('keydown', userEdit, true);
  };
  const userEdit = event => {
    if (event.isTrusted && event.target instanceof Element && event.target.closest('variant-selects,variant-radios,quantity-input,[data-lx-flow-accessories],.image-upload')) stopLate();
  };
  function watchLateInitialization() {
    stopLate();
    checkLate = () => {
      const root = productRoot();
      const mismatch = quantityInput()?.value !== String(state.quantity) || (state.swatches || []).some(saved => {
        const field = [...(root?.querySelectorAll('[data-lx-app-content] [id$="image-swatch"]') || [])].find(el => el.id === saved.id);
        return !field || JSON.stringify([...field.querySelectorAll('.c-active-option img')].map(imageKey).sort()) !== JSON.stringify([...saved.images].sort());
      });
      if (mismatch) { stopLate(); begin(); return false; }
      return true;
    };
    lateTimer = setInterval(() => checkLate(), 250);
    lateEnd = setTimeout(stopLate, 30000);
    for (const type of ['input','pointerdown','keydown']) document.addEventListener(type, userEdit, true);
  }
  document.addEventListener('click', event => {
    const control = event.target instanceof Element ? event.target.closest('product-form button[name="add"],.lxmp-action,.lxdp-action') : null;
    if (!control || restoring || failed) return;
    if (!checkLate()) { event.preventDefault(); event.stopImmediatePropagation(); }
    else stopLate();
  }, true);
  function begin() {
    stopLate();
    stop(); failed = false; stableSince = 0; synchronized = false; restoring = true;
    productRoot()?.removeAttribute('data-lx-restore-failed'); productRoot()?.setAttribute('data-lx-restoring', '');
    message(config.messages.busy, false);
    observer = new MutationObserver(schedule);
    observer.observe(productRoot() || document.getElementById('MainContent'), {childList:true, subtree:true});
    timer = window.setTimeout(() => finish(false), 45000);
    poll = window.setInterval(restore, 250);
    customElements.whenDefined('product-info').then(schedule);
    schedule();
  }
  begin();
})();
